import { createSlice } from "@reduxjs/toolkit";

export const mockSiteDevices = [];

export const onPremSiteDevicesSlice = createSlice({
  name: "onPremSiteDevices",
  initialState: {
    data: [...mockSiteDevices],
  },
});

export default onPremSiteDevicesSlice.reducer;